'use client';

export enum State {
    PENDING = 'PENDING',
    RESOLVED = 'RESOLVED',
    REJECTED = 'REJECTED',
    IDLE = 'IDLE',
    REVALIDATE = 'REVALIDATE',
}
